module.exports = __webpack_public_path__ + "static/media/15.d1bd9424.svg";